import React from "react";
import { IconCheck } from "@tabler/icons-react";

/**
 * A single filter group (e.g. "Location" or "Department"): a title and a list
 * of checkbox rows with a count badge. Multi-select.
 *
 * Props:
 * - title:    group heading
 * - options:  [{ value, label, count }]
 * - selected: array of selected values
 * - onToggle: (value) => void
 */
const FilterGroup = ({ title, options, selected, onToggle }) => {
  if (!options || options.length === 0) return null;

  return (
    <div className="jobsFilterGroup">
      <p className="jobsFilterTitle">{title}</p>
      <div className="jobsFilterItems">
        {options.map((option) => {
          const isChecked = selected.includes(option.value);
          return (
            <button
              type="button"
              key={option.value}
              className={`jobsFilterItem${isChecked ? " isChecked" : ""}`}
              onClick={() => onToggle(option.value)}
              aria-pressed={isChecked}
            >
              <span className="jobsCheckbox" aria-hidden="true">
                {isChecked && <IconCheck size={10} stroke={3} />}
              </span>
              <span className="jobsFilterLabel">{option.label}</span>
              <span className="jobsFilterCount">{option.count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FilterGroup;
